import React, { useState, useEffect } from 'react';
import './App.css';
import Header from './Header';
import MainContent from './MainContent';
import Features from './Features';
import CatalogPromo from './CatalogPromo';
import ProductGrid from './ProductGrid'; // Наш новый универсальный компонент
import Delivery from './Delivery';
import AboutSection from './AboutSection';
import Footer from './Footer';
import { LanguageProvider, useLanguage } from './LanguageContext';
import LanguageSwitcher from './LanguageSwitcher';
import AIChatBot from './AIChatBot';
import WhatsAppWidget from './WhatsAppWidget';
import FloatingActionsContainer from './components/FloatingActionsContainer';
import MobileApp from './MobileApp';
import ContactForm from './ContactForm';
import Snackbar from './Snackbar';
import DesktopVideo from './DesktopVideo';
import { sendContactData } from './services/contactService';
// ИМПОРТИРУЕМ ВСЕ НУЖНЫЕ ФУНКЦИИ ИЗ СЕРВИСА
import { getProducts, getCategories } from './firebase/productsService';
import ProductModal from './ProductModal'; // Импортируем модалку
import mattressImage from './assets/mattress.png';
const AppContent = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [snackbar, setSnackbar] = useState({ isOpen: false, message: '', type: 'success' });
  const { language, t } = useLanguage();
  const [categories, setCategories] = useState([]);
  const [allProducts, setAllProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  // Проверка на мобилку
  useEffect(() => {
    const checkIsMobile = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', checkIsMobile);
    return () => window.removeEventListener('resize', checkIsMobile);
  }, []);
  // Загрузка всех данных
  useEffect(() => {
    const loadInitialData = async () => {
      try {
        setLoading(true);
        const [categoriesData, productsData] = await Promise.all([
          getCategories(),
          getProducts()
        ]);
        const activeCategories = categoriesData.filter(cat => cat.isActive);
        setCategories(activeCategories);
        // Сортируем продукты по полю order (по возрастанию)
        // Если order отсутствует, используем 0 как значение по умолчанию
        const sortedProducts = [...productsData].sort((a, b) => {
          const orderA = a.order !== undefined ? a.order : 0;
          const orderB = b.order !== undefined ? b.order : 0;
          return orderA - orderB;
        });
        setAllProducts(sortedProducts);
      } catch (error) {
      } finally {
        setLoading(false);
      }
    };
    loadInitialData();
  }, []);
  // Предотвращаем автоматическую прокрутку к якорю
  useEffect(() => {
    if (window.location.hash) {
      window.scrollTo(0, 0);
      // Убираем хеш из URL без перезагрузки страницы
      window.history.replaceState(null, null, window.location.pathname);
    }
  }, []);
  // Хендлеры для формы
  const handleOpenForm = () => setIsFormOpen(true);
  const handleCloseForm = () => setIsFormOpen(false);
  // === УЛУЧШЕННАЯ, СУКА, ОБРАБОТКА ФОРМЫ ===
  const handleFormSubmit = async (formData) => {
    try {
      await sendContactData({ ...formData, source: 'desktop-main-form', language: language });
      // Показываем успех ТОЛЬКО если отправка удалась
      setSnackbar({
        isOpen: true,
        message: t('successMessage') || 'Спасибо! Мы скоро с вами свяжемся.',
        type: 'success'
      });
      // Данные из формы успешно отправлены
    } catch (error) {
      // Показываем ошибку, если что-то пошло не так
      setSnackbar({
        isOpen: true,
        message: t('errorMessage') || 'Ошибка отправки. Попробуйте позже.',
        type: 'error'
      });
      console.error('❌ Ошибка отправки данных из формы:', error);
    }
  };
  const handleCloseSnackbar = () => setSnackbar(prev => ({ ...prev, isOpen: false }));
  // Хендлеры для модалки товара
  const handleProductClick = (product) => {
    setSelectedProduct(product);
    setIsModalOpen(true);
  };
  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedProduct(null);
  };
  if (isMobile) {
    return <MobileApp />;
  }
  // === РЕНДЕРИНГ ДЕСКТОПНОЙ ВЕРСИИ ===
  return (
    <div className="page-wrapper">
      <div className="app-container">
        <div className="left-panel">
          <Header />
          <MainContent onOpenForm={handleOpenForm} />
        </div>
        <div className="right-panel">
          <img src={mattressImage} alt="Матрас на кровати" className="mattress-image" />
          <LanguageSwitcher />
        </div>
      </div>
      <Features />
      <CatalogPromo id="catalog" />
      <DesktopVideo />


      {loading ? (
        <div style={{ textAlign: 'center', padding: '100px' }}>Загрузка каталога...</div>
      ) : (
        categories.map(category => {
          const productsForCategory = allProducts.filter(p => (p.type || 'pruzhinnyy') === category.id);
          // Сортируем продукты внутри категории по полю order (по возрастанию)
          // Если order отсутствует, используем 0 как значение по умолчанию
          const sortedProductsForCategory = [...productsForCategory].sort((a, b) => {
            const orderA = a.order !== undefined ? a.order : 0;
            const orderB = b.order !== undefined ? b.order : 0;
            return orderA - orderB;
          });
          return sortedProductsForCategory.length > 0 ? (
            <ProductGrid
              key={category.id}
              title={category.title}
              subtitle={category.subtitle}
              products={sortedProductsForCategory}
              onProductClick={handleProductClick}
            />
          ) : null;
        })
      )}

      <Delivery />
      <AboutSection id="about" />
      <Footer id="contacts" />

      <FloatingActionsContainer>
        <AIChatBot />
        <WhatsAppWidget />
      </FloatingActionsContainer>

      <ContactForm isOpen={isFormOpen} onClose={handleCloseForm} onSubmit={handleFormSubmit} />
      <Snackbar isOpen={snackbar.isOpen} message={snackbar.message} type={snackbar.type} onClose={handleCloseSnackbar} />

      {isModalOpen && selectedProduct && (
        <ProductModal
          isOpen={isModalOpen}
          onClose={handleCloseModal}
          product={selectedProduct}
        />
      )}
    </div>
  );
};
function App() {
  return (
    <LanguageProvider>
      <AppContent />
    </LanguageProvider>
  );
}
export default App;